import React from 'react'
import { BellIcon } from '../../../Icons/BellIcon'

const MultipartyBanner = () => {
  return (
    <div className="purpleHeader">
      <div className="outerouter">
        <BellIcon />
        <div className="myStuff">
          <h4 className="stuffH2 ">
            We've made changes to this page and its layout to improve the
            developer experience
          </h4>
          <span className="stuffSpan">
            Let us know what you think of the updated documentation by selecting
            the feedback tab below.
          </span>
        </div>
      </div>
    </div>
  )
}

export default MultipartyBanner
